import { useMemo } from "react";

/**
 * useLocationMessageData - Data Layer hook para LocationMessageMC
 * Encapsula la obtención de datos puros del mensaje de ubicación.
 * Cumple con el estándar de separación de Mercately.
 *
 * @param {Object} message - Mensaje de ubicación
 * @param {Object} conversation - Conversación actual (con plataforma)
 * @returns {Object} Datos puros: latitude, longitude, inbound, locationURL
 */
export default function useLocationMessageData(message, conversation) {
  const latitude = useMemo(() => message.contentLocationLatitude, [message.contentLocationLatitude]);
  const longitude = useMemo(() => message.contentLocationLongitude, [message.contentLocationLongitude]);
  const inbound = useMemo(() => message.direction === 'inbound', [message.direction]);
  const locationURL = useMemo(() => message.locationURL, [message.locationURL]);
  const customerWebId = useMemo(() => conversation.customerWebId, [conversation.customerWebId]);

  return {
    latitude,
    longitude,
    inbound,
    locationURL,
    customerWebId
  };
}
